import * as ActionTypes from '../../constants/ActionTypes';

const initialState = {
    // Settings data
    settings: {
        appointment_enabled: false,
        business_hours: {
            monday: { enabled: false, start_time: "09:00", end_time: "17:00" },
            tuesday: { enabled: false, start_time: "09:00", end_time: "17:00" },
            wednesday: { enabled: false, start_time: "09:00", end_time: "17:00" },
            thursday: { enabled: false, start_time: "09:00", end_time: "17:00" },
            friday: { enabled: false, start_time: "09:00", end_time: "17:00" },
            saturday: { enabled: false, start_time: "09:00", end_time: "17:00" },
            sunday: { enabled: false, start_time: "09:00", end_time: "17:00" }
        },
        slot_duration: 30,
        slots_per_time: 2,
        advance_booking_days: 30,
        blocked_dates: [],
        auto_confirm: false,
        notifications: {
            email_enabled: true,
            sms_enabled: false
        },
        cancellation_policy: {
            allow_customer_cancellation: true,
            cancellation_hours_before: 24
        }
    },
    
    // Available dates for blocking interface
    availableDates: [],
    
    // Loading states
    loading: false,
    saving: false,
    availableDatesLoading: false,
    
    // Error states
    error: null,
    saveError: null,
    availableDatesError: null,
    
    // Success states
    saveSuccess: false,
    blockDateSuccess: false,
    unblockDateSuccess: false
};

const appointmentSettingsReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get appointment settings
        case ActionTypes.GET_APPOINTMENT_SETTINGS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
            
        case ActionTypes.GET_APPOINTMENT_SETTINGS_SUCCESS:
            return {
                ...state,
                loading: false,
                settings: action.payload,
                error: null
            };
            
        case ActionTypes.GET_APPOINTMENT_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
            
        // Update appointment settings
        case ActionTypes.UPDATE_APPOINTMENT_SETTINGS_REQUEST:
            return {
                ...state,
                saving: true,
                saveError: null,
                saveSuccess: false
            };
            
        case ActionTypes.UPDATE_APPOINTMENT_SETTINGS_SUCCESS:
            return {
                ...state,
                saving: false,
                settings: action.payload,
                saveError: null,
                saveSuccess: true
            };
            
        case ActionTypes.UPDATE_APPOINTMENT_SETTINGS_FAILURE:
            return {
                ...state,
                saving: false,
                saveError: action.payload,
                saveSuccess: false
            };
            
        // Add blocked date
        case ActionTypes.ADD_BLOCKED_DATE_REQUEST:
            return {
                ...state,
                saving: true,
                saveError: null,
                blockDateSuccess: false
            };
            
        case ActionTypes.ADD_BLOCKED_DATE_SUCCESS:
            return {
                ...state,
                saving: false,
                settings: {
                    ...state.settings,
                    blocked_dates: action.payload
                },
                saveError: null,
                blockDateSuccess: true
            };
            
        case ActionTypes.ADD_BLOCKED_DATE_FAILURE:
            return {
                ...state,
                saving: false,
                saveError: action.payload,
                blockDateSuccess: false
            };
            
        // Remove blocked date
        case ActionTypes.REMOVE_BLOCKED_DATE_REQUEST:
            return {
                ...state,
                saving: true,
                saveError: null,
                unblockDateSuccess: false
            };
            
        case ActionTypes.REMOVE_BLOCKED_DATE_SUCCESS:
            return {
                ...state,
                saving: false,
                settings: {
                    ...state.settings,
                    blocked_dates: action.payload
                },
                saveError: null,
                unblockDateSuccess: true
            };
            
        case ActionTypes.REMOVE_BLOCKED_DATE_FAILURE:
            return {
                ...state,
                saving: false,
                saveError: action.payload,
                unblockDateSuccess: false
            };
            
        // Get available dates
        case ActionTypes.GET_AVAILABLE_DATES_REQUEST:
            return {
                ...state,
                availableDatesLoading: true,
                availableDatesError: null
            };
            
        case ActionTypes.GET_AVAILABLE_DATES_SUCCESS:
            return {
                ...state,
                availableDatesLoading: false,
                availableDates: action.payload,
                availableDatesError: null
            };
            
        case ActionTypes.GET_AVAILABLE_DATES_FAILURE:
            return {
                ...state,
                availableDatesLoading: false,
                availableDatesError: action.payload
            };
            
        // Clear errors
        case ActionTypes.CLEAR_APPOINTMENT_SETTINGS_ERRORS:
            return {
                ...state,
                error: null,
                saveError: null,
                availableDatesError: null,
                saveSuccess: false,
                blockDateSuccess: false,
                unblockDateSuccess: false
            };
            
        // Reset state
        case ActionTypes.RESET_APPOINTMENT_SETTINGS_STATE:
            return {
                ...initialState
            };
            
        // Set loading
        case ActionTypes.SET_APPOINTMENT_SETTINGS_LOADING:
            return {
                ...state,
                loading: action.payload
            };
            
        default:
            return state;
    }
};

export default appointmentSettingsReducer;
